import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { TGeoObjectType } from 'components/domain/fdr-geo/fdr-geo-object.utils';
import { TFdrThGeoModuleObject } from 'components/domain/fdr-geo/fdr-geo.types';
import { LayoutContext } from 'components/domain/layout/Layout.context';
import { FdrPageComponentsFragment } from 'schemas/fragment/page-components/fdr-page-components.generated';
import { FdrGeoContentQuery } from 'schemas/query/geo/fdr-geo-content.generated';
import {
  Nav,
  NavContainer,
  NavItem,
  NavButton,
  NavUl,
} from './fdr-geo-navigation.styles';
import {
  handleNavigationClick,
  useGeoNavigation,
} from './fdr-geo-navigation.utils';

interface IGeoNavigationProps {
  geo: FdrGeoContentQuery['fdrGeo'];
  geoModules: TFdrThGeoModuleObject;
  pageComponents: FdrPageComponentsFragment;
  geoObjectType: TGeoObjectType;
}

const FdrGeoNavigation: React.FC<IGeoNavigationProps> = ({
  geo,
  geoModules,
  pageComponents,
  geoObjectType,
}) => {
  const [t] = useTranslation('geo');
  const { headerHeight } = useContext(LayoutContext);
  const { mobile } = useDeviceType();

  const navigationList = useGeoNavigation(
    geoObjectType,
    geo,
    geoModules,
    pageComponents
  );

  return (
    <Nav>
      <NavContainer>
        <NavUl>
          {navigationList.map(({ navId, title }) => {
            return (
              <NavItem key={navId}>
                <NavButton
                  variant="linkBtn"
                  onClick={() => {
                    handleNavigationClick(navId, headerHeight, mobile);
                  }}
                >
                  {t(title)}
                </NavButton>
              </NavItem>
            );
          })}
        </NavUl>
      </NavContainer>
    </Nav>
  );
};

export default FdrGeoNavigation;
